import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_320: DocMigration = {
  maxSchemaVersion: "0.0.320",
  description: "Removes orphaned instances of content templates",
  apply(json: any) {
    for (const id in json.contentTemplateInstances) {
      const contentTemplateInstance = json.contentTemplateInstances[id];

      if (!json.contentTemplates[contentTemplateInstance.contentTemplateId]) {
        delete json.contentTemplateInstances[id];
      }
    }

    return json;
  },
};

export default migration_0_0_320;
